module.exports = __webpack_public_path__ + "img/type_logo.7b2fe669.svg";